var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('button',{attrs:{"disabled":_vm.disabled},on:{"click":function($event){return _vm.$emit('click')}}},[_c('FontAwesomeIcon',{class:_vm.iconColorClass,attrs:{"icon":_vm.statusIcon,"spin":_vm.status === 'LOADING'}}),_vm._v(" "+_vm._s(_vm.statusText)+" ")],1)
}
var staticRenderFns = []

export { render, staticRenderFns }